import { render } from "./HelixToggleSwitch.vue?vue&type=template&id=5f03a54a"
import script from "./HelixToggleSwitch.vue?vue&type=script&lang=js"
export * from "./HelixToggleSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__